declare namespace Serenity {
    interface UserDefinition {

        exchangerate?: number;

    }

}
declare namespace Slick {
    interface GroupInfo<TItem> {
        displayTotalsRow?: boolean;
    }
}